import request from '@/api/request'
/**
 * 获取专题
 */
export function topicListApi () {
  return request({
    url: '/topic/list',
    method: 'get'
  })
}
/**
 * 获取专题详情
 */
export function topicInfoApi (query) {
  return request({
    url: '/topic/info',
    method: 'get',
    params: query
  })
}

/**
 * 获取公证知识与问题
 */
export function articleListApi (query) {
  return request({
    url: '/article/list',
    method: 'get',
    params: query
  })
}

/**
 * 点赞文章
 */
export function articleLikeApi (data) {
  return request({
    url: '/article/like',
    method: 'post',
    data
  })
}

/**
 * 获取文章详情
 */
export function articleInfoApi (query) {
  return request({
    url: '/article/info',
    method: 'get',
    params: query
  })
}

/**
 * 获取文章评论
 */
export function articleCommentListApi (query) {
  return request({
    url: '/article/comment_list',
    method: 'get',
    params: query
  })
}

/**
 * 评论文章
 */
export function articleCommentApi (data) {
  return request({
    url: '/article/comment',
    method: 'post',
    data
  })
}

/**
 * 获取文章相关业务
 */
export function articleNotaryListApi (query) {
  return request({
    url: '/article/notary',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/guide/index.js